<template>
  <div class="ResourceDialog">
    <!-- 新增、修改 -->
    <el-dialog
      title="资源列表"
      :visible.sync="dialogVisible"
      width="1200px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <!--数据表格-->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        height="600"
      >
        <el-table-column prop="id" label="ID" align="center" min-width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.id || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="视频标题"
          align="center"
          width="240"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.title || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="视频ID" align="center" width="360">
          <template slot-scope="scope">
            <span>{{ scope.row.vId || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cId" label="播单ID" align="center" width="240">
          <template slot-scope="scope">
            <span>{{ scope.row.cId || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="collectionName"
          label="播单名称"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.collectionName || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cover" label="封面图" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="!scope.row.cover">暂无封面图</span>
            <div
              v-else
              class="picturePreview">
              <img-load
                style="width: 80px; height: 80px"
                :src="imgUrl + scope.row.cover"
                fit="fill"
              ></img-load>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="collectionUid"
          label="播单ID"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.collectionUid || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="publisherID"
          label="作者ID"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.publisherID || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="是否开启"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">是</el-tag>
            <el-tag v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortCode" label="排序" align="center" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.sortCode || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatedAct"
          label="操作人"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.updatedAct || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <span>{{ changeTime(scope.row.updateTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="创建时间"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <span>{{ changeTime(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="280"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--分页组件-->
      <el-pagination
        :page-sizes="[10, 15, 20, 30]"
        :current-page="params.pageNumber"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      dialogVisible: false,
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        cId: undefined, // 播单ID
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      imgUrl: baseConfig.imgUrl,
    };
  },
  methods: {
    open(row) {
      this.params.cId = row.id;
      this.getList();
      this.dialogVisible = true;
    },
    getList() {
      API.getPlaylistVideoList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.title}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delPlaylistVideo(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleClose() {
      this.tableData = [];
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.ResourceDialog {
  .dialog-footer {
    position: relative;
    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
  }
  /deep/ .el-form-item__content {
    display: flex;
  }
  /deep/ .el-select {
    width: 100%;
  }
  /deep/ .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  /deep/ .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 130px;
  }
  /deep/ .el-dialog__body {
    padding: 30px 20px 50px;
  }
  /deep/ .el-pagination {
    margin-top: unset !important;
    padding: 10px 0;
  }
}
</style>
